"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _Stopover = require("@airasia/phoenix-components/components/Stopover");

var _Date = _interopRequireDefault(require("@airasia/phoenix-components/components/Date"));

var _constant2 = require("@airasia/phoenix-components/components/Date/constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _CarrierLogo = _interopRequireDefault(require("@airasia/phoenix-components/components/CarrierLogo"));

var _MobileHeaderNavigationMenu = _interopRequireDefault(require("./MobileHeaderNavigationMenu.proptypes"));

var _constant3 = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__MainWrapper",
  componentId: "sc-9kotdx-0"
})(["display:flex;align-items:center;justify-content:", ";padding:", ";box-shadow:", ";*:focus{}min-height:", ";", ""], function (_ref) {
  var isFlightInfo = _ref.isFlightInfo;
  return isFlightInfo ? 'flex-start' : 'space-between';
}, function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile;
  return isMobile ? "".concat(theme.space.tiny, " ").concat(theme.space.small) : "".concat(theme.space.none);
}, function (_ref3) {
  var boxShadow = _ref3.boxShadow;
  return boxShadow ? "0px 2px 6px rgba(0, 0, 0, 0.2)" : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.semiLarge);
}, function (_ref5) {
  var theme = _ref5.theme,
      detailedFlightInfo = _ref5.detailedFlightInfo,
      isRoundTrip = _ref5.isRoundTrip,
      isMobile = _ref5.isMobile;
  return detailedFlightInfo && isRoundTrip && !isMobile ? "\n          width: 50%;\n          border-right: 1px solid ".concat(theme.colors.greyLight, ";\n        ") : '';
});

var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__ContainerWrapper",
  componentId: "sc-9kotdx-1"
})(["display:flex;align-items:center;justify-content:flex-start;"]);

var DateWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__DateWrapper",
  componentId: "sc-9kotdx-2"
})(["display:flex;justify-content:center;", ""], function (_ref6) {
  var theme = _ref6.theme,
      isMobile = _ref6.isMobile,
      isFlightInfo = _ref6.isFlightInfo;
  return (// eslint-disable-next-line no-nested-ternary
    isFlightInfo && isMobile ? "padding: ".concat(theme.space.none, " ").concat(theme.space.none, "  ").concat(theme.space.none, "  ").concat(theme.space.micro) : isMobile ? "padding: ".concat(theme.space.none) : "padding: ".concat(theme.space.none, " ").concat(theme.space.micro, "  ").concat(theme.space.none, "  ").concat(theme.space.mini, ";")
  );
});

var SubtitleMainWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__SubtitleMainWrapper",
  componentId: "sc-9kotdx-3"
})(["display:flex;align-items:", ";justify-content:flex-start;height:", ";padding-left:", ";white-space:nowrap;"], function (_ref7) {
  var isMobile = _ref7.isMobile,
      isFlightInfo = _ref7.isFlightInfo;
  return isMobile && isFlightInfo ? 'baseline' : 'center';
}, function (_ref8) {
  var theme = _ref8.theme,
      isMobile = _ref8.isMobile;
  return !isMobile ? "".concat(theme.lineHeight.large) : null;
}, function (_ref9) {
  var theme = _ref9.theme,
      isMobile = _ref9.isMobile,
      detailedFlightInfo = _ref9.detailedFlightInfo;
  return (// eslint-disable-next-line no-nested-ternary
    !isMobile ? detailedFlightInfo ? "".concat(theme.space.large) : "".concat(theme.space.semiMedium) : null
  );
});

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__TextWrapper",
  componentId: "sc-9kotdx-4"
})(["display:flex;justify-content:flex-start;align-items:center;padding-right:", ";"], function (_ref10) {
  var theme = _ref10.theme,
      detailedFlightInfo = _ref10.detailedFlightInfo;
  return detailedFlightInfo ? "".concat(theme.space.tiny) : null;
});

var TitleMainWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__TitleMainWrapper",
  componentId: "sc-9kotdx-5"
})(["display:flex;justify-content:flex-start;height:", ";"], function (_ref11) {
  var theme = _ref11.theme,
      isMobile = _ref11.isMobile;
  return !isMobile ? "".concat(theme.lineHeight.titleNormal) : null;
});

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__TextContainer",
  componentId: "sc-9kotdx-6"
})(["display:flex;justify-content:flex-start;flex-direction:column;width:100%;margin-left:", ";"], function (_ref12) {
  var theme = _ref12.theme,
      detailedFlightInfo = _ref12.detailedFlightInfo;
  return detailedFlightInfo ? "".concat(theme.space.none) : "".concat(theme.space.small);
});

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__IconContainer",
  componentId: "sc-9kotdx-7"
})(["display:flex;align-items:center;justify-content:space-between;padding:", ";"], function (_ref13) {
  var theme = _ref13.theme,
      isMobile = _ref13.isMobile;
  return !isMobile ? "".concat(theme.space.none, " ").concat(theme.space.micro, "  ").concat(theme.space.none, "  ").concat(theme.space.tiny, " ") : "".concat(theme.space.none, "  ").concat(theme.space.micro);
});

var LinkContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__LinkContainer",
  componentId: "sc-9kotdx-8"
})(["display:flex;align-items:center;justify-content:space-between;padding:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.space.none, "  ").concat(theme.space.micro);
});

var DividerContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__DividerContainer",
  componentId: "sc-9kotdx-9"
})(["display:flex;align-items:center;justify-content:space-between;padding:", ";"], function (_ref15) {
  var theme = _ref15.theme,
      isMobile = _ref15.isMobile;
  return isMobile ? "".concat(theme.space.mini, " ").concat(theme.space.micro) : "".concat(theme.space.mini, " ").concat(theme.space.tiny);
});

var FlightContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileHeaderNavigationMenu__FlightContainer",
  componentId: "sc-9kotdx-10"
})(["display:flex;align-items:center;justify-content:space-between;padding-right:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.space.tiny);
});

var renderText = function renderText(text, type, color, bold) {
  return /*#__PURE__*/_react.default.createElement(ContainerWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    type: type,
    color: color,
    bold: bold
  }, text));
};

var renderLink = function renderLink(text, color, callback, tabIndex) {
  return /*#__PURE__*/_react.default.createElement(LinkContainer, {
    onClick: callback,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return callback;
      }, _constant3.KEY_CODE.ENTER);
    }
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    tabIndex: tabIndex,
    color: color,
    bold: true,
    customProperties: {
      fontWeight: _constant3.TEXT_TYPE.default.bold
    }
  }, text));
};

var returnCombinationText = function returnCombinationText(data, type, color, translation) {
  var label = "".concat((Number(data.guests.adult) + Number(data.guests.children) + Number(data.guests.infant)).toString(), " ").concat(translation[_constant3.PASSENGER_TYPES.combination]);
  return renderText(label, type, color, false);
};

var returnAdultText = function returnAdultText(data, type, color, translation) {
  var label = data.guests.adult > 1 ? "".concat(Number(data.guests.adult).toString(), " ").concat(translation[_constant3.PASSENGER_TYPES.manyAdults]) : "".concat(Number(data.guests.adult).toString(), " ").concat(translation[_constant3.PASSENGER_TYPES.oneAdult]);
  return renderText(label, type, color, false);
};

var renderReturnDate = function renderReturnDate(color, returnDate, format, size, showDateLabel, isMobile, locale, isFlightInfo, language) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DividerContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: showDateLabel ? _constant3.TEXT_TYPE.superSmall.size : _constant3.TEXT_TYPE.small.size,
    icon: showDateLabel ? _constant3.ICON_TYPES.DOT_ICON : _constant3.ICON_TYPES.REMOVE_ICON,
    theme: _constant.DEFAULT_THEME
  })), showDateLabel ? /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile
  }, renderText(language.return, // isMobile ? TEXT_TYPE.small.type : TEXT_TYPE.sub.type,
  isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true)) : null, /*#__PURE__*/_react.default.createElement(DateWrapper, {
    isMobile: isMobile,
    isFlightInfo: isFlightInfo
  }, /*#__PURE__*/_react.default.createElement(_Date.default, {
    accessible: false,
    allowLocaleFormat: false,
    locale: locale,
    color: color,
    date: returnDate,
    format: format // size={showDateLabel ? TEXT_TYPE.sub.size : TEXT_TYPE.small.type}
    ,
    size: isMobile ? _constant3.TEXT_TYPE.small.size : _constant3.TEXT_TYPE.sub.size
  })));
};

var renderIcon = function renderIcon(data, onClick) {
  return /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: _constant3.TEXT_TYPE.title.size,
    icon: _constant3.ICON_TYPES.BACK_ICON,
    theme: _constant.DEFAULT_THEME
  }));
};

var renderPassengersInfo = function renderPassengersInfo(data, translation, isMobile) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: _constant3.TEXT_TYPE.superSmall.size,
    icon: _constant3.ICON_TYPES.DOT_ICON,
    theme: _constant.DEFAULT_THEME
  })), /*#__PURE__*/_react.default.createElement(ContainerWrapper, null, data.guests.children + data.guests.infant + data.guests.adult > 0 ? returnCombinationText(data, _constant3.TEXT_TYPE.small.type, _constant3.TEXT_TYPE.small.color, translation) : returnAdultText(data, _constant3.TEXT_TYPE.small.type, _constant3.TEXT_TYPE.small.color, translation)));
};

var renderDepartureDate = function renderDepartureDate(showDateLabel, tripType, data, isMobile, locale, isFlightInfo) {
  return /*#__PURE__*/_react.default.createElement(DateWrapper, {
    isMobile: isMobile,
    isFlightInfo: isFlightInfo,
    accessible: false
  }, /*#__PURE__*/_react.default.createElement(_Date.default, {
    accessible: false,
    allowLocaleFormat: false,
    locale: locale,
    color: _constant3.TEXT_TYPE.small.color,
    date: new Date(data.date.departDate),
    format: new Date(data.date.departDate).getFullYear() === new Date(data.date.returnDate).getFullYear() && tripType === 'R' ? _constant2.DATE_FORMATS[_constant3.TRIP_DATE_FORMATS.SHORT] : _constant2.DATE_FORMATS[_constant3.TRIP_DATE_FORMATS.COMPLETE] // size={showDateLabel || isMobile ? TEXT_TYPE.small.type : TEXT_TYPE.sub.type}
    ,
    size: isMobile ? _constant3.TEXT_TYPE.small.size : _constant3.TEXT_TYPE.sub.size
  }));
};

var renderFlightInfoDate = function renderFlightInfoDate(showDateLabel, tripType, data, isMobile, locale, isFlightInfo) {
  return /*#__PURE__*/_react.default.createElement(DateWrapper, {
    isMobile: isMobile,
    isFlightInfo: isFlightInfo
  }, /*#__PURE__*/_react.default.createElement(_Date.default, {
    accessible: false,
    allowLocaleFormat: false,
    locale: locale,
    color: _constant3.TEXT_TYPE.small.color,
    date: new Date(data.date.departDate),
    format: tripType === 'R' && new Date(data.date.departDate).getFullYear() === new Date(data.date.returnDate).getFullYear() ? _constant2.DATE_FORMATS[_constant3.TRIP_DATE_FORMATS.SHORT] : _constant2.DATE_FORMATS[_constant3.TRIP_DATE_FORMATS.COMPLETE] // size={showDateLabel || isMobile ? TEXT_TYPE.small.size : TEXT_TYPE.sub.size}
    ,
    size: isMobile ? _constant3.TEXT_TYPE.small.size : _constant3.TEXT_TYPE.sub.size
  }));
};

var renderStandardFlightInfo = function renderStandardFlightInfo(isMobile, isFlightInfo, showDateLabel, language, tripType, data, locale, translation, showEditText, editTextCallback, tabIndex) {
  return /*#__PURE__*/_react.default.createElement(SubtitleMainWrapper, {
    isMobile: isMobile,
    isFlightInfo: isFlightInfo
  }, showDateLabel ? /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile
  }, renderText(language.departure, isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true)) : null, isFlightInfo ? renderFlightInfoDate(showDateLabel, tripType, data, isMobile, locale, isFlightInfo, language) : renderDepartureDate(showDateLabel, tripType, data, isMobile, locale, isFlightInfo, language), tripType === 'R' && data.date.returnDate ? renderReturnDate(_constant3.TEXT_TYPE.small.color, new Date(data.date.returnDate), _constant2.DATE_FORMATS[_constant3.TRIP_DATE_FORMATS.COMPLETE], _constant3.TEXT_TYPE.small.size, showDateLabel, isMobile, locale, isFlightInfo, language) : null, !showDateLabel ? renderPassengersInfo(data, translation, isMobile) : null, showEditText ? renderLink('Edit', _constant3.TEXT_TYPE.small.otaColor, editTextCallback, tabIndex) : null);
};

var createDivider = function createDivider(isMobile, detailedFlightInfo) {
  return /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile,
    detailedFlightInfo: detailedFlightInfo
  }, renderText('|', isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true));
};

var renderDetailedFlightInfo = function renderDetailedFlightInfo(isMobile, isFlightInfo, detailedFlightInfo, data, translation) {
  var segmentLength = data.segments ? data.segments.length - 1 : 0;
  return /*#__PURE__*/_react.default.createElement(SubtitleMainWrapper, {
    isMobile: isMobile,
    isFlightInfo: isFlightInfo,
    detailedFlightInfo: detailedFlightInfo
  }, /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile,
    detailedFlightInfo: detailedFlightInfo
  }, renderText(data.dateTime, isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true)), createDivider(isMobile, detailedFlightInfo), /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile,
    detailedFlightInfo: detailedFlightInfo
  }, renderText(data.flightTime, isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true)), createDivider(isMobile, detailedFlightInfo), /*#__PURE__*/_react.default.createElement(TextWrapper, {
    isMobile: isMobile,
    detailedFlightInfo: detailedFlightInfo
  }, renderText("".concat((0, _Stopover.generateDefaultStopText)(segmentLength, translation)), isMobile ? _constant3.TEXT_TYPE.small.type : _constant3.TEXT_TYPE.sub.type, _constant3.TEXT_TYPE.small.color, true)));
};

var MobileHeaderNavigationMenu = function MobileHeaderNavigationMenu(props) {
  var data = props.data,
      theme = props.theme,
      tripType = props.tripType,
      translation = props.translation,
      accessible = props.accessible,
      isIconEnabled = props.isIconEnabled,
      showDateLabel = props.showDateLabel,
      showBack = props.showBack,
      isFlightInfo = props.isFlightInfo,
      detailedFlightInfo = props.detailedFlightInfo,
      isRoundTrip = props.isRoundTrip,
      isMobile = props.isMobile,
      boxShadow = props.boxShadow,
      locale = props.locale,
      showEditText = props.showEditText,
      showCurrencyCTA = props.showCurrencyCTA,
      editTextCallback = props.editTextCallback,
      backIconCallback = props.backIconCallback,
      currencyCallback = props.currencyCallback;

  var language = _objectSpread(_objectSpread({}, _constant3.DATE_LABEL), translation);

  var tabIndex = !accessible ? '-1' : '0';
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  return data && data !== null && dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(MainWrapper, {
    tabIndex: tabIndex,
    isMobile: isMobile,
    boxShadow: boxShadow,
    isFlightInfo: isFlightInfo,
    detailedFlightInfo: detailedFlightInfo,
    isRoundTrip: isRoundTrip
  }, showBack ? renderIcon(data, backIconCallback) : null, /*#__PURE__*/_react.default.createElement(TextContainer, {
    detailedFlightInfo: detailedFlightInfo
  }, /*#__PURE__*/_react.default.createElement(TitleMainWrapper, {
    isMobile: isMobile,
    detailedFlightInfo: detailedFlightInfo
  }, isIconEnabled ? /*#__PURE__*/_react.default.createElement(FlightContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: _constant3.TEXT_TYPE.title.size // fontsize={isMobile ? TEXT_TYPE.default.size : TEXT_TYPE.title.size}
    ,
    icon: _constant3.ICON_TYPES.FLIGHT_ICON,
    theme: _constant.DEFAULT_THEME
  })) : null, detailedFlightInfo ? /*#__PURE__*/_react.default.createElement(FlightContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_CarrierLogo.default, {
    theme: theme,
    size: "large",
    placeHolderBackground: "default",
    carriers: data.carriers
  })) : null, /*#__PURE__*/_react.default.createElement(TextWrapper, null, renderText(detailedFlightInfo ? data.origin : data.route.origin, isFlightInfo && isMobile ? _constant3.TEXT_TYPE.default.type : _constant3.TEXT_TYPE.title.type, _constant3.TEXT_TYPE.default.color, true)), /*#__PURE__*/_react.default.createElement(IconContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: _constant3.TEXT_TYPE.title.size,
    icon: tripType === 'R' && !detailedFlightInfo ? _constant3.ICON_TYPES.ROUNDTRIP_ICON : _constant3.ICON_TYPES.ONEWAY_ICON,
    theme: _constant.DEFAULT_THEME
  })), /*#__PURE__*/_react.default.createElement(TextWrapper, null, renderText(detailedFlightInfo ? data.destination : data.route.destination, isFlightInfo && isMobile ? _constant3.TEXT_TYPE.default.type : _constant3.TEXT_TYPE.title.type, _constant3.TEXT_TYPE.default.color, true))), detailedFlightInfo ? renderDetailedFlightInfo(isMobile, isFlightInfo, detailedFlightInfo, data, translation) : renderStandardFlightInfo(isMobile, isFlightInfo, showDateLabel, language, tripType, data, locale, translation, showEditText, editTextCallback, tabIndex)), !isFlightInfo && showCurrencyCTA ? /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    onClick: currencyCallback
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: false,
    color: _constant3.TEXT_TYPE.small.color,
    fontsize: _constant3.TEXT_TYPE.title.size,
    icon: _constant3.ICON_TYPES.CHANGE_CURRENCY,
    theme: _constant.DEFAULT_THEME
  })) : /*#__PURE__*/_react.default.createElement("span", null))) : null;
};

MobileHeaderNavigationMenu.propTypes = _MobileHeaderNavigationMenu.default.PropTypes;
MobileHeaderNavigationMenu.defaultProps = _MobileHeaderNavigationMenu.default.DefaultProps;
var _default = MobileHeaderNavigationMenu;
exports.default = _default;